import {IS_USING_TESTNET} from "../../constants";

const PERA_EXPLORER_LINK_LABEL = "View on Pera Explorer";

function generatePeraExplorerLink(
  type: "group-id" | "txn-id" | "account-detail" | "asset-detail",
  id: string
): string {
  const origin = IS_USING_TESTNET
    ? "https://testnet.explorer.perawallet.app"
    : "https://explorer.perawallet.app";
  const encodedId = encodeURIComponent(id);

  let link = "";

  switch (type) {
    case "txn-id":
      link = `${origin}/tx/${encodeURIComponent(id)}/`;
      break;

    case "group-id":
      link = `${origin}/tx-group/${encodeURIComponent(id)}/`;
      break;

    case "asset-detail":
      link = `${origin}/assets/${encodedId}/`;
      break;

    case "account-detail":
      link = `${origin}/accounts/${encodedId}/`;
      break;

    default:
      break;
  }

  return link;
}

export {generatePeraExplorerLink, PERA_EXPLORER_LINK_LABEL};
